import { PillToggle } from '../../components/PillToggle';
import { useLanguage } from '../../contexts/LanguageContext';
import { setFormFactor, useFormFactor, type FormFactor } from './formFactor';

// MOBILE / DESKTOP, under the language in the sidebar's foot (see formFactor).
export function FormFactorToggle() {
  const { t } = useLanguage();
  const value = useFormFactor();
  const options: { value: FormFactor; label: string }[] = [
    { value: 'mobile', label: t('notice.formFactor.mobile') },
    { value: 'desktop', label: t('notice.formFactor.desktop') },
  ];
  return <PillToggle options={options} value={value} onChange={setFormFactor} />;
}
